import { Popover } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ToggleSwitch from 'views/pages/manage/common/form-fields-mui/ToggleSwitch';
import { getStatusCount } from './constant';
import {ReactComponent as EditIcon} from "assets/img/svg/EditBlackIcon.svg"

const statusSyncingSystemList = [
    { key: 'phx', title: 'PHX' },
    { key: 'sfWb', title: 'Salesforce & Website' },
];

const StatusSyncingDropdown = ({
    hasUpdate = true,
    statusValue,
    activeCount = 3,
    handler,
    anchorEl,
    setAnchorEl,
    view=false
}) => {

   
    const [value, setValue] = useState(statusValue);
    useEffect(()=>{
        setValue((prev)=>(statusValue))
    },[statusValue])

    const containerRef = useRef(null); // Step 1: ref

    const onToggleClick = (key) => {
        setValue(prev => ({
            ...prev,
            [key]: prev?.[key] === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
        }));
    };

    const editHandler = () => {
        setAnchorEl(containerRef.current); // Step 2: use outer div as anchor
        setValue(statusValue);
    };

    const saveHandler = () => {
        handler(value);
        setAnchorEl(null);
    };

const statusStyle = {
    INACTIVE	: {
      backgroundColor: "#FFEDC8",
      color: "#705010",
      padding: "4px 11px",
      fontSize: "14px",
      borderRadius: "8px",
    },
    ACTIVE: {
      backgroundColor: "#BBE2CE",
      color: "#0B442D",
      padding: "4px 11px",
      fontSize: "14px",
      borderRadius: "8px",
    },
  };
   const statusMapping = {
    ACTIVE: "Active",
    INACTIVE: 'Inactive',
  };
  console.log('status',value)
    return (
        <>

            {!view&&<div
                ref={containerRef}
                className="d-flex justify-content-between align-items-center border rounded-xl px-4 py-2 w-fit"
            >
                <span className="font-semibold text-black">
                    <span className="font-normal">{getStatusCount(statusValue)}</span>
                </span>
                    <EditIcon className='cursor' onClick={editHandler}/>
            </div>}

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                disableAutoFocus
                disableEnforceFocus
                disableRestoreFocus
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                PaperProps={{
                    sx: {
                        maxHeight: 300,
                        pointerEvents: 'auto'
                    }
                }}
            >
                {!view&&<div className='d-flex justify-content-end'>
                    <AButton
                        variant="link"
                        size="xs"
                        className='mr-4 mt-2'
                        onClick={(e) => {
                            e.stopPropagation();
                            saveHandler();
                        }}
                    >
                        Save
                    </AButton>

                </div>}
                {view && <div style={{padding: '16px 20px 16px 20px' }} className='color-grey-60 tiny-semi-bold'>BRANCH STATUS</div> }
                <div
                    className="d-flex flex-column"
                    style={{ gap: '16px', padding: '16px 20px 16px 20px' }}
                >
                    {statusSyncingSystemList.map((item, idx) => (<>
                        <div
                            key={idx}
                            className="cursor d-flex justify-content-between align-items-center"
                        >
                            <div className="regular-bolder color-grey-80" style={{width:'150px'}}>
                                {item?.title}
                            </div>
                            <div>
                                {console.log(view,value,statusValue,'itemValue')}
                               { view?<div className={`ellipsis-text-container`}style={statusStyle?.[value?.[item.key]]} >{statusMapping?.[value?.[item.key]]}</div>
                               :
                                <ToggleSwitch
                                    checked={value?.[item.key] === "ACTIVE"}
                                    onClick={() =>
                                        hasUpdate ? onToggleClick(item?.key) : undefined
                                    }
                                    disabled={!hasUpdate}
                                />
}
                            </div>
                        </div>
                        {idx!=statusSyncingSystemList.length-1&&<div className='mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>}
                        </>
                    ))}
                </div>
            </Popover>
        </>
    );
};

export default StatusSyncingDropdown;
